import React, { useState } from "react";
import JsPDF from "jspdf";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CloseButton,
  TextInputField,
} from "../../../../../../components/atoms";
import NumberSpace from "../../../../../global-functions/NumberSpace";

const CashRegisterCount = ({
  display,
  onCloseClick,
  selectedReportIndex,
  setLoading,
  setMessage,
  setToastPop,
  setCashRegisterOpenCheck,
  selectedReport,
  selectedBudtender,
  setCashRegisterReset,
  cashRegisterReset,
  setCashRegsiterStatus,
  setOPenedBy,
  setDateAndTimeOpened,
  setCountTill,
  storeUsers,
}) => {
  const [downloading, setDownloading] = useState(false);
  const [cashCounted, setCashCounted] = useState("");
  const [cardCounted, setCardCounted] = useState("");

  const [salesList, setsalesList] = useState([]);

  const createTipsArrayDisplay = ({ userId }) => {
    if (display && display.tipRecieptsArray) {
      let usersRest = [...display.tipRecieptsArray];

      let valueArray = [];

      for (let index = 0; index < usersRest.length; index++) {
        const element = usersRest[index];

        usersRest.map((item) =>
          userId === element.cashierId
            ? valueArray.push(Number(item.amount))
            : null
        );
      }

      let tipsTotal = valueArray.reduce(function (x, y) {
        return x + y;
      }, 0);

      return tipsTotal;
    } else {
      return 0;
    }
  };

  let ExVatCheck = display
    ? (Number(display.TotalInc) - Number(display.vat)).toFixed(2)
    : 0;

  const generatePDF = async () => {
    // prescriptionPdf();
    setDownloading(true);
    const report = await new JsPDF("portrait", "px", "a4");
    report.html(document.querySelector("#reportClosedReg")).then(() => {
      report.getFontList();
      report.setFont("Courier");
      report.save(`report${new Date().toDateString()}.pdf`);
    });
    setDownloading(false);
  };

  const generateSalesPDF = async () => {
    // prescriptionPdf();
    setDownloading(true);
    const report = await new JsPDF("portrait", "px", "a4");
    report.html(document.querySelector("#reportSalesItems")).then(() => {
      // report.getFontList();
      // report.setFont("Courier");
      report.save(`report${new Date().toDateString()}.pdf`);
    });
    setDownloading(false);
  };

  const StockSheet = () => {
    return (
      <div
        id="reportSalesItems"
        style={{
          fontFamily: "Arial",
          position: "absolute",
          zIndex: -2,
          width: 450,
          backgroundColor: BlackAndWhite.secondary,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowX: "hidden",
        }}
      >
        {/* // header base info */}
        <div
          style={{
            minHeight: 100,
            width: "100%",
            display: "flex",
            alignItems: "center",
            // marginTop: 3,
            maxWidth: 450,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 14,
                fontWeight: "bold",
                color: "#5F6469",
                marginLeft: 20,
                marginTop: 5,
              }}
            >
              STOCK SHEET - {display ? display.storeName : "loading"}
            </div>
            <div style={{ fontSize: 12, marginLeft: 20, marginTop: 5 }}>
              {new Date().toDateString()}
            </div>
          </div>
          <div style={{ flex: 1 }} />
          <div
            style={{
              marginRight: 20,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                marginTop: 5,
                fontSize: 12,
                fontWeight: "bold",
                color: "#5F6469",
                marginLeft: 10,
              }}
            >
              {" "}
              TIME REQUESTED
            </div>
            <div
              style={{
                fontSize: 14,
                marginLeft: 10,
                color: "#000000",
                marginTop: 5,
              }}
            >
              {new Date().toLocaleTimeString()}
            </div>
          </div>
        </div>
        {/* list header */}
        <div
          style={{
            width: "80%",
            maxWidth: 450,
            minWidth: 450,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            fontSize: 10,
            borderStyle: "solid",
            paddingTop: 5,
            paddingBottom: 5,
            borderColor: "#CBD1D8",
            backgroundColor: "#CBD1D8",
          }}
        >
          <div style={{ flex: 0.7, display: "flex", alignItems: "center" }}>
            <div style={{ marginLeft: 10 }}>PRODUCT NAME</div>
          </div>
          <div style={{ flex: 0.15, display: "flex", alignItems: "center" }}>
            SOLD QTY
          </div>
        </div>
        {salesList ? (
          salesList.map((item, index) => {
            return item.totalCount >= 1 ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  borderBottomStyle: "solid",
                  borderBottomWidth: 0.5,
                }}
                key={index}
              >
                <div style={{ flex: 0.7 }}>
                  <div style={{ marginLeft: 10 }}>
                    {" "}
                    {item.product.productName}
                  </div>
                </div>

                <div
                  style={{ flex: 0.3, display: "flex", alignItems: "center" }}
                >
                  {item.totalCount}
                </div>
              </div>
            ) : null;
          })
        ) : (
          <div>LOADING...</div>
        )}
      </div>
    );
  };
  console.log("cashCounted", cashCounted, "cardCounted", cardCounted);
  const updateCashRegisterReportCount = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/cashRegister/updateReportCounted",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            registerId: display.registerId,
            cashCounted,
            cardCounted,
            userId: selectedBudtender._id,
            expectedCash: display ? Number(display.cash).toFixed(2) : 0,
            expectedCard: display ? Number(display.card).toFixed(2) : 0,
          }),
        }
      );

      const responseData = await response.json();
      console.log("slaes response", responseData);
      if (responseData.success) {
        await generatePDF();
        await setsalesList(responseData.fullSalesList);
        console.log(salesList);
        setMessage("CASH REGISTER CLOSED");
        setToastPop(true);
        setCountTill(null);

        setCashRegisterReset(cashRegisterReset ? false : true);
        setCashRegsiterStatus("closed");
        setOPenedBy("closed");
        setDateAndTimeOpened("closed");
        setCardCounted("");
        setCashCounted("");
        setTimeout(async () => {
          await generateSalesPDF();
          setCashRegisterOpenCheck(null);
          setLoading(false);
        }, 1000);
      } else {
        setMessage(responseData.message);
        setToastPop(true);
        setLoading(false);
      }
    } catch (err) {
      console.log("error", err);
      setMessage("Error occured check your network connection");
      setToastPop(true);
      setLoading(false);
    }
  };
  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: display ? "100%" : 0,
        backgroundColor: BlackAndWhite.secondary,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        overflowY: "scroll",
        overflowX: "hidden",
        top: 0,
        left: 0,
        zIndex: 10000000000000,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* <CloseButton label={"X"} onClick={onCloseClick} /> */}
        <div
          style={{
            marginLeft: 10,
            fontWeight: "normal",
            fontSize: 16,
            display: "flex",
          }}
        >
          CASH REGISTER REPORT FOR{" "}
          <div style={{ marginLeft: 5, fontWeight: "bold" }}>
            {display
              ? new Date(display.openedAt).toLocaleDateString() +
                " / " +
                new Date(display.openedAt).toLocaleTimeString() +
                " TO " +
                new Date(display.closedAt).toLocaleDateString() +
                " / " +
                new Date(display.closedAt).toLocaleTimeString()
              : null}
          </div>
        </div>
      </div>
      {/* <div
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          mini={true}
          label={"DOWNLOAD"}
          marginTop={-1}
          //   invert={true}
          height={40}
          borderRadius={8}
          onClick={() => generatePDF()}
        />
      </div> */}
      <div style={{ minHeight: 60 }}></div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div
          style={{
            WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          }}
        >
          <div
            // key={selectedReportIndex}
            id="reportClosedReg"
            style={{
              display: "flex",
              flexDirection: "column",
              width: 450,
              position: "relative",
              minHeight: 625,
              fontFamily: "Arial",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 20,
                display: "flex",
                flexDirection: "column",
                fontSize: 12,
              }}
            >
              CASH REGISTER {selectedReportIndex ? selectedReportIndex : null}
              <div style={{ fontSize: downloading ? 14 : 10 }}>
                {display ? display.storeName : null}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 20,
                left: 210,

                display: "flex",
                flexDirection: "column",
                textAlign: "right",
                fontSize: 12,
              }}
            >
              REGISTER SUMMARY{" "}
              {selectedReportIndex ? selectedReportIndex : null}
              <div style={{ fontSize: 10 }}>
                {display
                  ? display.openedAt.substring(0, 10) +
                    " - " +
                    display.openedAt.substring(11, 19) +
                    "  TO  "
                  : null}

                {display
                  ? display.closedAt.substring(0, 10) +
                    " - " +
                    display.closedAt.substring(11, 19)
                  : null}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 80,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "105%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    flex: 1,
                  }}
                >
                  <div style={{ marginLeft: 10 }}> Payment Type</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  <div style={{ marginLeft: 3 }}>Expected</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  <div style={{ marginLeft: 3 }}>Counted</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 10,
                    width: 60,
                    textAlign: "right",
                    paddingLeft: 3,
                  }}
                >
                  <div style={{ marginLeft: 3 }}>Difference</div>
                </div>
              </div>

              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 105,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}>
                  Cash (net cash payments) (float:{" "}
                  {display
                    ? "R" + NumberSpace({ value: display.tillOpeningAmount })
                    : null}
                  )
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display ? "R" + Number(display.cash).toFixed(2) : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display ? "R" + Number(cashCounted).toFixed(2) : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display
                    ? "R" +
                      (
                        Number(display.cash) +
                        Number(display.tillOpeningAmount) -
                        Number(cashCounted)
                      ).toFixed(2)
                    : null}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 125,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}>
                  Card
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display ? "R" + Number(display.card).toFixed(2) : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display ? "R" + Number(cardCounted).toFixed(2) : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  R0.00
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 145,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}>
                  Credit
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display
                    ? "R" + Number(display.storeCredit).toFixed(2)
                    : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  {display
                    ? "R" + Number(display.storeCredit).toFixed(2)
                    : null}
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 60,
                    textAlign: "right",
                  }}
                >
                  R0.00
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 165,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 175,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  Payments:
                  <div style={{ flex: 1 }} />
                  {display ? "R" + Number(display.TotalInc).toFixed(2) : null}
                  <div
                    style={{
                      position: "absolute",
                      minHeight: 1,
                      maxHeight: 1,
                      backgroundColor: "#C0C0C1",
                      width: "100%",
                      bottom: -5,
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 195,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  Refunds:
                  <div style={{ flex: 1 }} />
                  {display ? "- R" + Number(display.refunds).toFixed(2) : null}
                  <div
                    style={{
                      position: "absolute",
                      minHeight: 1,
                      maxHeight: 1,
                      backgroundColor: "#C0C0C1",
                      width: "100%",
                      bottom: -5,
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 215,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    width: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  Net receipts:
                  <div style={{ flex: 1 }} />
                  {display ? "R" + Number(display.TotalInc).toFixed(2) : null}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 230,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 240,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    minWidth: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  Total (Incl) Sales:
                  <div style={{ flex: 1 }} />
                  {display ? "R" + Number(display.TotalInc).toFixed(2) : null}
                  {/* <div
                  style={{
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: 0.5,
                    width: 120,
                    bottom: -5,
                  }}
                /> */}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 260,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    minWidth: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    alignItems: "center",
                  }}
                >
                  Total (Ex) Sales: <div style={{ flex: 1 }} />
                  {display ? "R" + ExVatCheck : null}
                  {/* <div
                  style={{
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: 0.5,
                    width: 120,
                    bottom: -5,
                  }}
                /> */}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 280,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                {/* <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    minWidth: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    alignItems: "center",
                  }}
                >
                  Total Vat:{" "}
                  <div style={{ fontSize: 7, marginLeft: 3 }}>
                    {display
                      ? "(R" + Number(display.TotalInc).toFixed(2) + ")"
                      : null}
                  </div>
                  <div style={{ flex: 1 }} />
                  {display ? "R" + Number(display.vat).toFixed(2) : null}
                  {/* <div
                  style={{
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: 0.5,
                    width: 120,
                    bottom: -5,
                  }}
                /> */}
                {/* </div> */}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 300,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    minWidth: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    alignItems: "center",
                  }}
                >
                  Discounts:
                  <div style={{ flex: 1 }} />
                  {display ? "R" + Number(display.discounts).toFixed(2) : null}
                  {/* <div
                  style={{
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: 0.5,
                    width: 120,
                    bottom: -5,
                  }}
                /> */}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 320,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{ fontWeight: "normal", fontSize: 8, flex: 1 }}
                ></div>

                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,
                    minWidth: 120,
                    textAlign: "right",
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    alignItems: "center",
                  }}
                >
                  Till Opening Amt.:
                  <div style={{ flex: 1 }} />
                  {display
                    ? "R" + Number(display.tillOpeningAmount).toFixed(2)
                    : null}
                  {/* <div
                  style={{
                    position: "absolute",
                    borderStyle: "solid",
                    borderWidth: 0.5,
                    width: 120,
                    bottom: -5,
                  }}
                /> */}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 340,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 345,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,
                    flex: 1,
                    display: "flex",
                  }}
                >
                  <div>Transaction</div>
                  <div style={{ marginLeft: 40, fontWeight: "bold" }}>User</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,

                    display: "flex",
                  }}
                >
                  Action
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 360,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 365,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 7,
                    flex: 1,
                    display: "flex",
                  }}
                >
                  <div>Opening float</div>
                  <div style={{ marginLeft: 40 }}>
                    {display ? display.openedBy : null}
                  </div>
                </div>
                <div
                  style={{
                    fontWeight: "normal",
                    fontSize: 8,

                    display: "flex",
                  }}
                >
                  +{" "}
                  {display
                    ? "R" + Number(display.tillOpeningAmount).toFixed(2)
                    : null}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 380,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 385,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,
                    flex: 1,
                    display: "flex",
                  }}
                >
                  <div>Num. of transctions</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,

                    display: "flex",
                  }}
                >
                  Average Sale
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 400,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 405,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,
                    flex: 1,
                    display: "flex",
                  }}
                >
                  <div>{display ? display.receiptsArray.length : null}</div>
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,

                    display: "flex",
                  }}
                >
                  {display
                    ? "R" + Number(display.averageSale).toFixed(2)
                    : null}
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 420,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  minHeight: 1,
                  backgroundColor: "#C0C0C1",
                  width: "100%",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 430,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div style={{ display: "flex", width: "100%", marginBottom: 2 }}>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: 8,
                    flex: 1,
                  }}
                >
                  <div style={{ marginBottom: 10 }}>
                    {display ? "Opened by:" + display.openedBy : null}
                  </div>
                  <div>{display ? "Closed by:" + display.closedBy : null}</div>
                </div>
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                top: 490,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                width: "90%",
                fontSize: 10,
              }}
            >
              <div style={{ textAlign: "left", fontSize: 9 }}>
                STORE CASHIERS TIPS
              </div>
              <div style={{ flex: 1 }} />
              <div style={{ fontSize: 9 }}>AMOUNT DUE</div>
            </div>

            <div
              style={{
                position: "absolute",
                top: 505,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <div
                style={{
                  // borderStyle: "solid",
                  width: "100%",

                  minHeight: 1,
                  // marginTop: 15,
                  backgroundColor: "#C0C0C1",
                }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                top: 515,
                left: 20,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                width: "90%",
              }}
            >
              {storeUsers
                ? storeUsers.map((item, index) => {
                    return (
                      <div
                        key={index}
                        style={{
                          width: "100%",
                          marginTop: 5,
                          display: "flex",
                          alignItems: "center",
                          fontSize: 8,
                        }}
                      >
                        <div style={{ width: 150, textAlign: "left" }}>
                          {item ? item.firstName + " " + item.lastName : null}
                        </div>
                        <div style={{ flex: 1 }} />

                        <div style={{ width: 200, textAlign: "right" }}>
                          {item && display
                            ? "R" +
                              createTipsArrayDisplay({
                                userId: item._id,
                              }).toFixed(2)
                            : null}
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </div>
        <div
          style={{
            width: 350,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: 600,
            textAlign: "left",
            marginLeft: 40,
          }}
        >
          <div style={{ width: "90%", fontSize: 18, fontWeight: "bold" }}>
            CASH AMOUNT EXPECTED
          </div>
          <div style={{ width: "90%", marginBottom: 10, marginTop: 5 }}>
            (Float:{" "}
            {display
              ? "R" + Number(display.tillOpeningAmount).toFixed(2)
              : "loading"}
            )
          </div>
          <div style={{ width: "90%", fontSize: 35, fontWeight: "bold" }}>
            {display ? "R" + Number(display.cash).toFixed(2) : "loading"}
          </div>
          <TextInputField
            labelTitle={"CASH COUNT"}
            invert={true}
            mini={true}
            size={280}
            value={cashCounted}
            onChange={(e) => setCashCounted(e.target.value)}
            height={80}
            fontsize={cashCounted !== "" ? 45 : 20}
            placeholder={"ADD AMOUNT HERE"}
            borderRadius={8}
          />
          <div style={{ width: "90%", marginTop: 20, marginBottom: 10 }}>
            CARD AMOUNT EXPECTED
          </div>
          <div style={{ width: "90%", fontSize: 35, fontWeight: "bold" }}>
            {display ? "R" + Number(display.card).toFixed(2) : "loading"}
          </div>
          <TextInputField
            labelTitle={"CARD SLIPS COUNT"}
            invert={true}
            mini={true}
            value={cardCounted}
            size={280}
            onChange={(e) => setCardCounted(e.target.value)}
            height={80}
            fontsize={cardCounted !== "" ? 45 : 20}
            placeholder={"ADD AMOUNT HERE"}
            borderRadius={8}
          />

          <BaseButtons
            label={"CONFIRM TOTALS & GENERATE REPORT"}
            size={310}
            mini={true}
            onClick={() => updateCashRegisterReportCount()}
            disable={cardCounted !== "" && cashCounted !== "" ? false : true}
          />
        </div>
      </div>
      {<StockSheet />}
    </div>
  );
};

export default CashRegisterCount;
